import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { Role, UserAdmin } from '../../shared/models/user.model';

declare const moment: (input: number) => { format: (pattern: string) => string };

const DAY_MILLISECONDS = 86400000;

export const lastTestRequestedColumn: ColDef<UserAdmin> = {
  headerName: 'Last test requested',
  field: 'lastTestRequestedAt',
  initialHide: true,
  minWidth: 105,
  maxWidth: 120,
  sortable: true,
  comparator: () => 0,
  sortingOrder: ['desc', 'asc', null],
  cellRenderer: (params: ICellRendererParams<UserAdmin>) => renderLastTestRequested(params.data),
};

export function renderLastTestRequested(user: UserAdmin | undefined, now = Date.now()): string {
  if (user?.role !== Role.MAIN) return '<div class="one-line">–</div>';
  const requestedAt = user.lastTestRequestedAt ? new Date(user.lastTestRequestedAt).getTime() : NaN;
  if (!Number.isFinite(requestedAt) || requestedAt <= 0) {
    return '<div class="one-line"><span class="far fa-frown text-error-r3 me-0_5" aria-label="Never requested a test"></span>Never</div>';
  }
  const days = Math.max(0, Math.floor((now - requestedAt) / DAY_MILLISECONDS));
  const indicator = days < 7 ? 'fa-smile text-success-s2' : days < 15 ? 'fa-meh text-accent-a2' : 'fa-frown text-error-r3';
  const date = moment(requestedAt).format('DD/MM/YY');
  const recency = `Last test requested ${days} ${days === 1 ? 'day' : 'days'} ago`;
  return `<div class="one-line"><span class="far ${indicator} me-0_5" title="${recency}" aria-label="${recency}"></span>${date}</div>`;
}
